<template>
  <div class="companywrap">
      <!-- 头部 -->
      <top></top>
      <el-row class="hidden-sm-and-up">
        <el-col>
          <div class="mineNav-left">
            <ul class="mineNav">
              <li @click="toPath('/mine')">{{$t('exhibitor.personal')}}</li>
              <li @click="show(0)">
                <p>{{$t('exhibitor.collect')}} <i class="el-icon-arrow-down"></i></p>
                <ul class="minesubnav" v-if="isSHowSub">
                  <li @click.stop="collectMChange(0)">{{$t('exhibitor.product')}}</li>
                  <li class="active" @click.stop="collectChange(1)">{{$t('exhibitor.enterprise')}}</li>
                  <li @click.stop="collectMChange(2)">{{$t('navMenu.active')}}</li>
                </ul>
              </li>
              <!-- <li @click="show(1)">
                <p>{{$t('exhibitor.demand')}} 
                  <i class="el-icon-arrow-down"></i>
                </p>
                <ul class="minesubnav"  v-if="isSHowSubDemand">
                  <li @click.stop="demandMChange(0)">{{$t('exhibitor.sendDemand')}}</li>
                  <li @click.stop="demandMChange(1)">{{$t('exhibitor.myAnswer')}}</li>
                  <li @click.stop="demandMChange(2)">{{$t('exhibitor.enterpriseMessage')}}</li>
                </ul>
              </li> -->
              <li @click="toPath('/feedback')">{{$t('exhibitor.feedback')}}</li>
              <!-- <li class="inbox" @click="toPath('/inbox')">{{$t('business.inboxs')}}</li> -->
            </ul>
          </div>
        </el-col>
      </el-row>
      <el-row class="exmain">
        <el-col :xs="xsNumLeft" :sm="xsNumLeft" :md="3" :lg="3" :xl="4"></el-col>
        <el-col :xs="xsNumLeftNav" :sm="xsNumLeftNav" :md="5" :lg="2" :xl="2" class="hidden-sm-and-down">
          <div class="mineNav-left">
            <ul class="mineNav">
              <li @click="toPath('/mine')">{{$t('exhibitor.personal')}}</li>
              <li @click="show(0)">
                <p>{{$t('exhibitor.collect')}} <i class="el-icon-arrow-right"></i></p>
                <ul class="minesubnav" v-if="isSHowSub">
                  <li @click.stop="collectChange(0)">{{$t('exhibitor.product')}}</li>
                  <li class="active" @click.stop="collectChange(1)">{{$t('exhibitor.enterprise')}}</li>
                  <li @click.stop="collectChange(2)">{{$t('navMenu.active')}}</li>
                </ul>
              </li>
              <!-- <li @click="show(1)">
                <p>{{$t('exhibitor.demand')}} <i class="el-icon-arrow-right"></i></p>
                <ul class="minesubnav"  v-if="isSHowSubDemand">
                  <li @click.stop="demandChange(0)">{{$t('exhibitor.sendDemand')}}</li>
                  <li @click.stop="demandChange(1)">{{$t('exhibitor.myAnswer')}}</li>
                  <li @click.stop="demandChange(2)">{{$t('exhibitor.enterpriseMessage')}}</li>
                </ul>
              </li> -->
              <li @click="toPath('/feedback')">{{$t('exhibitor.feedback')}}</li>
              <!-- <li class="inbox" @click="toPath('/inbox')">{{$t('business.inboxs')}}</li> -->
            </ul>
          </div>
        </el-col>
        <el-col :xs="xsNum" :sm="xsNum" :md="14" :lg="14" :xl="10">
          <div class="main-right" :style="{minHeight:height}">
            <div class="companyWrap" v-if="companyList.length > 0">
              <div class="companylist" v-for="(item, index) in companyList" :key="item.id" @click="toDetail(item.id)">
                <!-- 图片自适应外层盒子 -->
                <div v-if="item.logo.length > 0" class="img_divout">
                  <img  class="logo" :src="$imgUrl + item.logo" alt="">
                </div>
                <div v-else class="img_divout">
                  <img  class="logo" src="../../../assets/logo.jpg" alt="">
                </div>
                <div class="middle">
                  <p v-if="langSet == 'zh' || item.enCompanyName.length == 0" class="title">{{item.companyName}}</p>
                  <p v-if="langSet == 'en' && item.enCompanyName.length > 0" class="title">{{item.enCompanyName}}</p>
                  <p>
                    <span v-if="langSet == 'zh' || item.en_country.length == 0">{{item.country}}</span>
                    <span v-if="langSet == 'en' && item.en_country.length > 0" >{{item.en_country}}</span>
                    <span v-if="item.province.length > 0 || item.en_country.length > 0">-</span>
                    <span v-if="langSet == 'zh' || item.en_province.length == 0">{{item.province}}</span>
                    <span v-if="langSet == 'en' && item.en_province.length > 0" >{{item.en_province}}</span>
                  </p>
                  <p v-if="langSet == 'zh' || item.en_exhibitionArea.length == 0" class="sub">
                    <span>{{item.exhibitionArea}}</span>
                    <span v-if="item.hallNo.length!= 0 || item.boothNo.length > 0">/</span>
                    <span>{{item.hallNo}}</span>
                    <span>{{item.boothNo}}</span>
                  </p>
                  <p v-if="langSet == 'en' && item.en_exhibitionArea.length > 0" class="sub">
                    <span>{{item.en_exhibitionArea}}</span>
                    <span v-if="item.boothNo.length > 0">/</span>
                    <span>{{item.en_hallNo}}</span>
                    <span>{{item.boothNo}}</span>
                  </p>
                </div>
                <div class="right">
                    <img class="collect-icon" v-if="item.isCollect == 0" @click.stop="collectBtn(item.id, 1, index)" src="../../../assets/collect.png" alt="">
                    <img class="collect-icon" v-if="item.isCollect == 1" @click.stop="collectBtn(item.id, 0, index)" src="../../../assets/collect_en.png" alt="">
                    <div class="carrow">
                      <p class="el-icon-arrow-right carrow-right"></p>
                      <p class="eye-icon"><img src="../../../assets/eye.png" alt="">{{item.clicknum}}</p>
                    </div>
                </div>
              </div>
            </div>
            <el-pagination
              v-if="companyList.length > 0"
              background
              :page-size = pagesize
              layout="total,prev, pager, next"
              @current-change="changePage"
              :total="total">
            </el-pagination>
            <div class="nodata" v-if="companyList.length == 0">
              <img v-if="langSet == 'zh'" src="../../../assets/nodata.png" alt="">
              <img v-else src="../../../assets/nodata01.png" alt="">
            </div>
          </div>
        </el-col>
        <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="4"></el-col>
      </el-row>
      <!-- 底部 -->
      <bottom></bottom>
  </div>
</template>

<script>
import top from "../../../components/top.vue";
import bottom from "../../../components/bottom.vue";
import { getCompanyList, getCollect } from "@/api/api";
export default {
  components: { top,  bottom},
  name: "mine",
  data() {
    return {
      isSHowSub:true,
      isSHowSubDemand:false,
      keywords: '',
      business_1: '',
      business_2: '',
      productClass_1: '',
      productClass_2: '',
      country: '',
      showareaid: '',
      pagesize: 11,
      page: '1',
      companyList:[],
      total: 0,
      height:'',
      langSet: '',
      xsNumLeft: 1,
      xsNumLeftNav: 4,
      xsNum: 18
    }
  },
  created() {
  },
  mounted() {
    this.langSet = localStorage.getItem('languageSet') || 'zh';
    this.memberid = localStorage.getItem('memberid');
    this.getList();
    this.setHeight();
    if(this._isMobile()) {
      this.isSHowSub = false;
      this.xsNumLeft = 1;
      this.xsNumLeftNav = 0;
      this.xsNum = 22;
    }else{
      this.isSHowSub = true;
      this.xsNumLeft = 1;
      this.xsNumLeftNav = 4;
      this.xsNum = 18;
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    setHeight(){
        this.height = window.innerHeight  - 145 + 'px';
    },
    show(id){
      if(id == 0){
        this.isSHowSub = !this.isSHowSub;
      }else{
        this.isSHowSubDemand = !this.isSHowSubDemand;
      }
    },
    getList(){
      let data =this.$qs.stringify({
        memberid: this.memberid,
        act: "collect",
        pagesize: this.pagesize,
        page: this.page
      });
      var that=this;
      //console.log(data)
      getCompanyList(data).then(res=>{
        //console.log(res.data)
        if(res.data.errno == 0){
          console.log(res.data.rst)
          that.companyList = res.data.rst;
          that.total = Number(res.data.errmsg);
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    changePage(val){
      this.page = val;
      this.getList()
    },
    collectChange(index){
      if(index == 0){
        this.$router.push({
          name: 'myproduct'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'mycompany'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'myactive'
        });
      }
    },
    collectMChange(index){
      if(index == 0){
        this.$router.push({
          name: 'myproduct'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'mycompany'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'myactive'
        });
      }
      this.isSHowSub = !this.isSHowSub;
    },
    demandMChange(index){
      if(index == 0){
        this.$router.push({
          name: 'demandissue'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'myresponse'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'mymessage'
        });
      }
      this.isSHowSubDemand = !this.isSHowSubDemand;
    },
    demandChange(index){
      if(index == 0){
        this.$router.push({
          name: 'demandissue'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'myresponse'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'mymessage'
        });
      }
    },
    collectBtn(id,state,index){
      //console.log(id)
      let data = this.$qs.stringify({
        memberid: this.memberid,
        type: 2,
        dataid: id,
        status: state
      })
      let message = this.companyList;
      getCollect(data).then(res=>{
        //console.log(res)
        if(res.data.errno == 0){
          for (let i in message) {
            if (i == index) {
              if (message[i].isCollect == 1) {
                message[i].isCollect = 0
              } else {
                message[i].isCollect = 1
              }
            }
          }
          console.log(message)
          this.companyList = message;
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    toDetail(id){
      //console.log(id)
      this.$router.push({
        name:"exhibitorDetail",
        query:{id}
      });
    },
    toPath(path){
      this.$router.push({path});
    }
  }
}
</script>

<style lang="scss" scoped>
.exmain .main-right{box-sizing: border-box;}
.main{padding-top: 40px;padding-left: 184px;}
.mineNav > li{font-size:20px;line-height:28px;color: #000;margin-bottom: 24px;cursor: pointer;width: 100px;text-align: center;}
.mineNav > li.active{color: #CAC28A;}
.mineNav > li p{position: relative;}
.mineNav > li p i{position: absolute;top: 5px;}
.mineNav > li .minesubnav{color: #666;font-size:18px;line-height: 25px;padding-bottom: 13px;text-align: center;}
.mineNav > li .minesubnav li{padding-top: 14px;}
.mineNav > li .minesubnav .active{color: #CAC28A;}
.companyWrap{min-height: 600px;}
.companylist{border-radius:9px;border:2px solid #979797;padding: 11px 33px 11px 11px;box-sizing: border-box;display: flex;justify-content: space-between;margin-bottom: 20px;cursor: pointer;}
.companylist .img_divout {
width:98px;height:98px;border-radius:2px;border:1px solid #ccc;display: flex; align-items: center; overflow: hidden;
}
.companylist .logo{ width: 100%;}
.companylist .middle{flex: 1;padding-left: 27px;color:rgba(0,0,0,0.5);font-size: 20px;line-height: 20px;display: flex;flex-wrap: wrap;}
.companylist .middle p{width: 100%;}
.companylist .middle .sub{align-self: flex-end;}
.companylist .middle .title{font-size:22px;color: #000;font-weight: 600;line-height: 32px;}
.companylist .right{display: flex;padding-top: 35px;box-sizing: border-box;}
.companylist .right .collect-icon{width: 24px;height: 24px;margin-right: 27px;}
.companylist .right .carrow-right{font-size: 36px;font-weight: bold;line-height: 30px;margin-bottom: 20px;}
.companylist .right .eye-icon{color: #7F7F7F;font-size: 14px;}
.companylist .right .eye-icon img{width:12px;height:8px;margin-right: 6px;}
.nodata{padding-top: 200px;}
.mineNav > li.inbox{background:rgba(224,153,149,1);border-radius:4px;color: #fff;font-size: 18px;}
@media only screen and (max-width: 767px){
  .mineNav{
    padding: 0 0.2rem;
    display: flex;
    margin-top: 0.2rem;
    li.inbox{font-size: 11px;}
    li{
      font-size: 11px;
      flex: 1;
      position: relative;
      margin-bottom: 0;
      p i{top: 0.18rem;}
      .minesubnav{
        font-size: 11px;
        line-height: 0.25rem;
        position: absolute;
        background: #fff;
        width: 100%;
        z-index: 999;
        li{padding-top: 0.14rem;}
      }
    } 
  }
  .nodata{width: 75%;}
  .companylist{padding:0.1rem;}
  .companylist .logo{width:100%;}
  .companylist .middle .title{font-size: 14px;line-height: 0.3rem;}
  .companylist .middle{padding-left: 0.2rem;font-size: 12px;}
  .companylist .right .collect-icon{width: 0.24rem;height: 0.24rem;margin-right: 0.2rem;}
  .companylist .right{padding-top: 0.3rem;}
  .companylist .right .carrow-right{font-size: 18px;margin-bottom: 0.2rem;line-height: 0.3rem;}
  .companywrap .el-pagination{height: 0.52rem;padding:0.05rem;}
  .companywrap .el-pagination button, .companywrap .el-pagination span:not([class*=suffix]){height: 0.36rem;line-height: 0.36rem;font-size: 12px;}
  .companywrap .el-pagination.is-background .el-pager li {width: 0.41rem;height: 0.41rem;line-height: 0.41rem;}
  .companywrap .el-pager li{font-size: 12px;}
  .el-pager, .el-pager li{vertical-align: middle;}
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{min-width: auto;}
  .companywrap .el-pagination .btn-next .el-icon, .companywrap .el-pagination .btn-prev .el-icon{font-size: 18px;line-height: 0.44rem;}
}
</style>